import React, { useState, useEffect } from 'react';
import { Container, Card, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/authService';

const VerifyLink = () => {
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  useEffect(() => {
    if (token) {
      verifyEmail(token);
    } else {
      setStatus('error');
      setMessage('Invalid verification link. Please request a new one.');
    }
  }, [token]);

  const verifyEmail = async (token) => {
    try {
      const response = await authService.verifyEmail(token);
      
      if (response.message === "Email is already verified") {
        setStatus('verified');
        setMessage('Your email is already verified. You can now login to your account.');
      } else if (response.isVerified) {
        setStatus('verified');
        setMessage('Email verified successfully! You can now login to your account.');
      } else {
        setStatus('error');
        setMessage('Verification failed. Please request a new verification link.');
      }
    } catch (err) {
      setStatus('error');
      setMessage(err.response?.data?.message || 'Verification failed. Please try again.');
    }
  };

  const getStatusIcon = () => {
    switch (status) {
      case 'verifying':
        return <Spinner animation="border" variant="primary" />;
      case 'verified':
        return <i className="fas fa-check-circle text-success" style={{ fontSize: '48px' }}></i>;
      case 'error':
        return <i className="fas fa-exclamation-circle text-danger" style={{ fontSize: '48px' }}></i>;
      default:
        return null;
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Card className="p-4 shadow" style={{ maxWidth: '500px', width: '100%' }}>
        <Card.Body className="text-center">
          <div className="mb-4">
            {getStatusIcon()}
          </div>

          <h4 className="mb-4">Email Verification</h4>

          {status === 'verifying' && (
            <div className="mb-4">
              <p>Verifying your email address...</p>
            </div>
          )}

          {message && (
            <Alert 
              variant={status === 'verified' ? 'success' : 'danger'} 
              className="mb-4"
            >
              {message}
            </Alert>
          )}

          {(status === 'verified' || status === 'error') && (
            <div className="d-grid gap-2">
              <Button 
                variant="primary" 
                onClick={() => navigate('/auth/login')}
                className="mt-3"
              >
                Go to Login
              </Button>
              {status === 'error' && (
                <Button 
                  variant="outline-primary" 
                  onClick={() => navigate('/auth/verify-email')}
                  className="mt-2"
                >
                  Request New Verification Link
                </Button>
              )}
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default VerifyLink; 